import { FC } from 'react';
import { Box } from '@mui/material';
import DBHeader from 'src/components/Headers/DialogBoxHeader';
import Scrollbar from 'src/components/StyledComponents/StyledScrollbar';
import {
  StyledDialogContent,
  CloseIcon,
  StyledDialog,
  FieldLabel,
  FieldValue,
} from 'src/components/DialogBox/DialogBox.styles';
import { Production } from 'src/models/Management.interface';

interface ProductionViewDialogProps {
  open: boolean;
  handleClose: () => void;
  production: Production | null;
  title: string;
  subtitle: string;
}

const ProductionViewDialog: FC<ProductionViewDialogProps> = ({
  open,
  handleClose,
  production,
  title,
  subtitle,
}) => {
  return (
    <StyledDialog
      open={open}
      onClose={handleClose}
      width="600px"
      height="350px"
    >
      <Box sx={{ position: 'relative' }}>
        <DBHeader title={title} subtitle={subtitle} />
        <CloseIcon
          component="i"
          className="bx bx-x-circle"
          onClick={handleClose}
        />
      </Box>
      <Scrollbar thumbColor="var(--loader-color)">
        <StyledDialogContent>
          <Box ml={5} mr={5} mt={3} mb={4}>
            <Box display="flex" gap={4}>
              <Box flex={1}>
                <FieldLabel>Product Name</FieldLabel>
                <FieldValue>{production?.productName || 'N/A'}</FieldValue>
              </Box>
              <Box
                flex={1}
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
              >
                <FieldLabel>Production Date</FieldLabel>
                <FieldValue>{production?.productionDate || 'N/A'}</FieldValue>
              </Box>
            </Box>
            <Box display="flex" gap={4}>
              <Box flex={1}>
                <FieldLabel>Produced Quantity</FieldLabel>
                <FieldValue>{production?.producedQuantity ?? 'N/A'}</FieldValue>
              </Box>
              <Box
                display="flex"
                flexDirection="column"
                alignItems="flex-start"
                flex={1}
              >
                <FieldLabel>Damaged Quantity</FieldLabel>
                <FieldValue>{production?.damagedQuantity ?? 'N/A'}</FieldValue>
              </Box>
            </Box>
          </Box>
        </StyledDialogContent>
      </Scrollbar>
    </StyledDialog>
  );
};

export default ProductionViewDialog;
